import { HotelBtsCoverageProperties } from "@website/accommodation-ui/hotel-bts-coverage/hotel-bts-coverage.types";
import { LazyImage } from "@website/ui/lazy-image";
import { deepCompare } from "@website/utils/deep-compare";
import { memo } from "react";

const Component = ({
  btsCoverage
}: {
  btsCoverage: HotelBtsCoverageProperties;
}) => {
  if (!btsCoverage?.length) return null;
  return (
    <div className="flex flex-col justify-start gap-4">
      <div className="text-subtitle-1 md:text-headline-6">وضعیت آنتن دهی</div>
      <div className="grid grid-cols-2 flex-row items-center gap-y-6 md:flex md:flex-wrap md:gap-[164px]">
        {btsCoverage.map((item) => (
          <div className="flex flex-row items-center gap-2">
            {item?.logo && (
              <LazyImage src={item?.logo} width={40} height={20} />
            )}
            <div className="flex flex-col gap-1">
              <span className="text-subtitle-2">{item?.cellOperator}</span>
              <span className="text-body-2 text-on-surface-medium-emphasis">
                {item?.coverageType}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export const HotelBTSCoverage = memo(Component, deepCompare);
